import styled from 'styled-components';
import { Center } from '.';
import { colors } from '../../globalStyles';

export const ListCentered = styled.div({ textAlign: 'center' });

export const ListRow = styled(Center as any)({
  padding: '5px 0px',
  fontWeight: 'bold',
});

export const ListIcon = styled.i((props: { checked?: boolean; }) => ({
  paddingLeft: '5px',
  marginTop: '-3px',
  color: props.checked ? colors.green : colors.red,
}));
